<div [ngClass]="containerClass()" [ngStyle]="containerStyle()">

	<ng-container [ngSwitch]="mode">
		<!-- <ng-container *ngSwitchCase="AvatarMode.Text">
			<div class="w-avatar-text">{{value}}</div>
		</ng-container>
		<ng-container *ngSwitchCase="AvatarMode.Image">
			<img class="w-avatar-image" [src]="value" alt="avatar" (error)="imageError($event)">
		</ng-container>
		<ng-container *ngSwitchCase="AvatarMode.Icon">
			<div class="w-avatar-icon"><i class="fa" [ngClass]="value"></i></div>
		</ng-container> -->
		<ng-container *ngSwitchCase="AvatarMode.Template">
			<ng-content></ng-content>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<img class="w-avatar-image" [src]="value | svgAvatar:mode:border" (error)="imageError($event)" alt="avatar" />
		</ng-container>
	</ng-container>

	<!-- <i [ngClass]="[statusIcon, 'status-icon']" *ngIf="statusIcon"></i> -->

</div>